"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base = exports.createFontStyle = void 0;
var polished_1 = require("polished");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var responsive_1 = require("../../utils/responsive");
var StyledText = styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: block;\n  text-align: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n\n  ", "\n"], ["\n  display: block;\n  text-align: ", ";\n  color: ", ";\n  font-weight: ", ";\n  font-style: ", ";\n\n  ", "\n"])), function (_a) {
    var align = _a.align;
    return align;
}, function (_a) {
    var textColor = _a.textColor;
    return textColor;
}, function (_a) {
    var weight = _a.weight;
    return weight;
}, function (_a) {
    var italic = _a.italic;
    return (italic ? 'italic' : 'normal');
}, function (_a) {
    var textSizes = _a.textSizes;
    return (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    font-size: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), (0, polished_1.rem)(textSizes[0]), textSizes[1] && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), (0, responsive_1.small)((0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        font-size: ", ";\n      "], ["\n        font-size: ", ";\n      "])), (0, polished_1.rem)(textSizes[1])))), textSizes[2] && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), (0, responsive_1.medium)((0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        font-size: ", ";\n      "], ["\n        font-size: ", ";\n      "])), (0, polished_1.rem)(textSizes[2])))), textSizes[3] && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      ", "\n    "], ["\n      ", "\n    "])), (0, responsive_1.large)((0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        font-size: ", ";\n      "], ["\n        font-size: ", ";\n      "])), (0, polished_1.rem)(textSizes[3])))));
});
/**
 * Use as little as possible!
 * In nearly all cases it should be possible to use an existing Typography component
 * (exported from the Typography index.ts, e.g BodyText.tsx, HeadingText.tsx etc)
 */
var createFontStyle = function (_a) {
    var size = _a.size, weight = _a.weight;
    return (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n    ", ";\n  "], ["\n    ", ";\n    ", ";\n  "])), weight && "font-weight: ".concat(weight), size && "font-size: ".concat((0, polished_1.rem)(size)));
};
exports.createFontStyle = createFontStyle;
/**
 * Do not render this component directly!
 * You should render it through the abstractions provided by the Typography components
 * (exported from Typography index.ts, e.g BodyText.tsx, HeadingText.tsx etc)
 */
exports.Base = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.align, align = _b === void 0 ? 'left' : _b, weight = _a.weight, _c = _a.italic, italic = _c === void 0 ? false : _c, color = _a.color, className = _a.className, sizes = _a.sizes, children = _a.children, props = __rest(_a, ["align", "weight", "italic", "color", "className", "sizes", "children"]);
    var theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(StyledText, __assign({ align: align, textSizes: sizes, textColor: color, weight: weight !== null && weight !== void 0 ? weight : theme.typography.fontWeights.regular, italic: italic, className: className, ref: ref }, props), children));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
